import { SendLaudoMedicoUI } from './sendLaudoMedicoUI'
import { useSendDocuments } from '../../hooks/useSendDocuments/useSendDocuments'

function SendLaudoMedico() {
  const props = useSendDocuments()
  return <SendLaudoMedicoUI {...props} />
}

export default SendLaudoMedico